export const GET_STATION_REALTIME_REPORT_SUCCESS = 'GET_STATION_REALTIME_REPORT_SUCCESS'